import { render } from "./help_classification.vue?vue&type=template&id=2b73c12c&ts=true"
import script from "./help_classification.vue?vue&type=script&lang=ts"
export * from "./help_classification.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__